const TOOL_COSTS = Object.freeze({
  chatbot: 1,

  mindmap: 10,
  flashcards: 10,
  quiz: 10,
  notes: 10,

  synthese: 15,
  exercises: 13,
  mindmap_svg: 13,

  image: 25,
  generate_pack: 35,
  bossfight: 15,
})

export function getToolCost(toolId) {
  return TOOL_COSTS[toolId] || 0
}

export default {
  TOOL_COSTS,
  getToolCost,
}
